import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Work", href: "#work" },
  { label: "Coaching", href: "#coaching" },
  { label: "Press", href: "#press" },
  { label: "Get in Touch", href: "#services" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-white/75 border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => handleNav(e, "#top")}
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <span className="font-display text-[18px] font-medium text-[#0A0A0A] tracking-[-0.02em]">
            Binaifer Dulani
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] font-medium text-[#3A3A3A] hover:text-[#0A0A0A] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#booking"
          onClick={(e) => handleNav(e, "#booking")}
          data-testid="nav-cta-book"
          className="hidden md:inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-[#0A0A0A] text-white text-[13px] font-medium hover:bg-[#1F1F1F] transition-colors duration-300"
        >
          Book a Session
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full text-[#0A0A0A] hover:bg-black/5 transition-colors"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-black/5 bg-white/95 backdrop-blur-2xl"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleNav(e, l.href)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base font-medium text-[#0A0A0A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={(e) => handleNav(e, "#booking")}
              data-testid="nav-mobile-cta-book"
              className="mt-2 inline-flex items-center justify-center px-5 py-3 rounded-full bg-[#0A0A0A] text-white text-sm font-medium"
            >
              Book a Session
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
